// Dependencies
import { Col, Row } from 'antd'
import React from 'react'
import ExperienceSection from './ExperienceSection';
import EducationSection from './EducationSection';
import SkillsSection from './SkillsSection';
import './index.css'
import ButtonsSection from './ButtonsSection';

// Interface
interface Props {
    educationListForm: Array<any>;
    experienceListForm: Array<any>;
    skillListForm: Array<any>;
}

// Component
const CandidateCard: React.FC<Props> = ({ educationListForm, experienceListForm, skillListForm }) => {

    return (
        <Row className='container-candidate-card'>
            <Row>
                <Col xs={{ span: 22 }} lg={{ span: 23 }} xl={{ span: 23 }} xxl={{ span: 12 }} className='container-subsection-experience' >
                    <ExperienceSection experience={experienceListForm} />
                </Col>

                <Col xs={{ span: 22 }} lg={{ span: 23 }} xl={{ span: 23 }} xxl={{ span: 12 }} className='container-subsection-education'>
                    <EducationSection education={educationListForm} />
                </Col>
            </Row>

            <Row className='container-section-two'>
                <SkillsSection skills={skillListForm} />
            </Row>

            <Row className='container-section-button'>
                <ButtonsSection />
            </Row>
        </Row>
    )
}

export default CandidateCard